import { render, staticRenderFns } from "./PackageBasedPricing.vue?vue&type=template&id=5be50ea6&scoped=true&"
import script from "./PackageBasedPricing.vue?vue&type=script&lang=js&"
export * from "./PackageBasedPricing.vue?vue&type=script&lang=js&"
import style0 from "./PackageBasedPricing.vue?vue&type=style&index=0&id=5be50ea6&lang=scss&scoped=true&"
import style1 from "./PackageBasedPricing.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be50ea6",
  null
  
)

export default component.exports